import { render, staticRenderFns } from "./CheckoutStepAddress.vue?vue&type=template&id=4b7d1a2c&"
import script from "./CheckoutStepAddress.vue?vue&type=script&lang=js&"
export * from "./CheckoutStepAddress.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutStepAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports